import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { CreateOrderBatchInput } from './CreateOrderBatchInput';
import { CreateOrderBatchOutput } from './CreateOrderBatchOutput';

export class CreateOrderBatchService extends HttpServiceBase {

  handle = (input: CreateOrderBatchInput): Promise<Result<CreateOrderBatchOutput> | null> => {
    const promise = this.http.post<Result<CreateOrderBatchOutput>, CreateOrderBatchInput>(`${this.baseUrlSislogApi}/v2/order/batch`, input);
    return promise;
  }
}